/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Latestoffers_Title1Inputs */

const id_components_latestoffers_title1 = /** @type {(inputs: Components_Latestoffers_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terbaru Ditambahkan`)
};

const ms_components_latestoffers_title1 = /** @type {(inputs: Components_Latestoffers_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terkini Ditambah`)
};

const da_components_latestoffers_title1 = /** @type {(inputs: Components_Latestoffers_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Senest Tilføjede`)
};

const de_components_latestoffers_title1 = /** @type {(inputs: Components_Latestoffers_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neueste hinzugefügte`)
};

const en_us2_components_latestoffers_title1 = /** @type {(inputs: Components_Latestoffers_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Latest Added`)
};

const es_es2_components_latestoffers_title1 = /** @type {(inputs: Components_Latestoffers_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Últimas añadidas`)
};

const es_mx2_components_latestoffers_title1 = /** @type {(inputs: Components_Latestoffers_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agregados recientemente`)
};

const fil_components_latestoffers_title1 = /** @type {(inputs: Components_Latestoffers_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mga Pinakabagong Idinagdag`)
};

const fr_components_latestoffers_title1 = /** @type {(inputs: Components_Latestoffers_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dernières ajoutées`)
};

const it_components_latestoffers_title1 = /** @type {(inputs: Components_Latestoffers_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ultimi aggiunti`)
};

const hu_components_latestoffers_title1 = /** @type {(inputs: Components_Latestoffers_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Legutóbb hozzáadott`)
};

const nl_components_latestoffers_title1 = /** @type {(inputs: Components_Latestoffers_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recent toegevoegd`)
};

const no_components_latestoffers_title1 = /** @type {(inputs: Components_Latestoffers_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nylig lagt til`)
};

const pl_components_latestoffers_title1 = /** @type {(inputs: Components_Latestoffers_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ostatnio dodane`)
};

const pt_br2_components_latestoffers_title1 = /** @type {(inputs: Components_Latestoffers_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Latest Added`)
};

const pt_components_latestoffers_title1 = /** @type {(inputs: Components_Latestoffers_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adicionados recentemente`)
};

const ro_components_latestoffers_title1 = /** @type {(inputs: Components_Latestoffers_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adăugate recent`)
};

const fi_components_latestoffers_title1 = /** @type {(inputs: Components_Latestoffers_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Viimeksi lisätyt`)
};

const sv_components_latestoffers_title1 = /** @type {(inputs: Components_Latestoffers_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Senast tillagda`)
};

const vi_components_latestoffers_title1 = /** @type {(inputs: Components_Latestoffers_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã thêm gần đây`)
};

const tr_components_latestoffers_title1 = /** @type {(inputs: Components_Latestoffers_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Son Eklenenler`)
};

const cs_components_latestoffers_title1 = /** @type {(inputs: Components_Latestoffers_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Naposledy přidané`)
};

const bg_components_latestoffers_title1 = /** @type {(inputs: Components_Latestoffers_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Последно добавени`)
};

const ru_components_latestoffers_title1 = /** @type {(inputs: Components_Latestoffers_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Последние добавленные`)
};

const uk_components_latestoffers_title1 = /** @type {(inputs: Components_Latestoffers_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Нещодавно додані`)
};

const ar_components_latestoffers_title1 = /** @type {(inputs: Components_Latestoffers_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`آخر ما تمت إضافته`)
};

const hi_components_latestoffers_title1 = /** @type {(inputs: Components_Latestoffers_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`नवीनतम जोड़े गए`)
};

const th_components_latestoffers_title1 = /** @type {(inputs: Components_Latestoffers_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ล่าสุดที่เพิ่ม`)
};

const ja_components_latestoffers_title1 = /** @type {(inputs: Components_Latestoffers_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新着`)
};

const zh_cn2_components_latestoffers_title1 = /** @type {(inputs: Components_Latestoffers_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Latest Added`)
};

const zh_hant1_components_latestoffers_title1 = /** @type {(inputs: Components_Latestoffers_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Latest Added`)
};

const ko_components_latestoffers_title1 = /** @type {(inputs: Components_Latestoffers_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Latest Added`)
};

/**
* | output |
* | --- |
* | "Latest Added" |
*
* @param {Components_Latestoffers_Title1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_latestoffers_title1 = /** @type {((inputs?: Components_Latestoffers_Title1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Latestoffers_Title1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_latestoffers_title1(inputs)
	if (locale === "ms") return ms_components_latestoffers_title1(inputs)
	if (locale === "da") return da_components_latestoffers_title1(inputs)
	if (locale === "de") return de_components_latestoffers_title1(inputs)
	if (locale === "en-US") return en_us2_components_latestoffers_title1(inputs)
	if (locale === "es-ES") return es_es2_components_latestoffers_title1(inputs)
	if (locale === "es-MX") return es_mx2_components_latestoffers_title1(inputs)
	if (locale === "fil") return fil_components_latestoffers_title1(inputs)
	if (locale === "fr") return fr_components_latestoffers_title1(inputs)
	if (locale === "it") return it_components_latestoffers_title1(inputs)
	if (locale === "hu") return hu_components_latestoffers_title1(inputs)
	if (locale === "nl") return nl_components_latestoffers_title1(inputs)
	if (locale === "no") return no_components_latestoffers_title1(inputs)
	if (locale === "pl") return pl_components_latestoffers_title1(inputs)
	if (locale === "pt-BR") return pt_br2_components_latestoffers_title1(inputs)
	if (locale === "pt") return pt_components_latestoffers_title1(inputs)
	if (locale === "ro") return ro_components_latestoffers_title1(inputs)
	if (locale === "fi") return fi_components_latestoffers_title1(inputs)
	if (locale === "sv") return sv_components_latestoffers_title1(inputs)
	if (locale === "vi") return vi_components_latestoffers_title1(inputs)
	if (locale === "tr") return tr_components_latestoffers_title1(inputs)
	if (locale === "cs") return cs_components_latestoffers_title1(inputs)
	if (locale === "bg") return bg_components_latestoffers_title1(inputs)
	if (locale === "ru") return ru_components_latestoffers_title1(inputs)
	if (locale === "uk") return uk_components_latestoffers_title1(inputs)
	if (locale === "ar") return ar_components_latestoffers_title1(inputs)
	if (locale === "hi") return hi_components_latestoffers_title1(inputs)
	if (locale === "th") return th_components_latestoffers_title1(inputs)
	if (locale === "ja") return ja_components_latestoffers_title1(inputs)
	if (locale === "zh-CN") return zh_cn2_components_latestoffers_title1(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_latestoffers_title1(inputs)
	return ko_components_latestoffers_title1(inputs)
});
export { components_latestoffers_title1 as "components.latestOffers.title" }